import { render, staticRenderFns } from "./kdxHintText.g.vue?vue&type=template&id=37677978&scoped=true"
import script from "./kdxHintText.g.vue?vue&type=script&lang=js"
export * from "./kdxHintText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHintText.g.vue?vue&type=style&index=0&id=37677978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37677978",
  null
  
)

export default component.exports